import { ApiService } from 'src/app/services/api.service';
import { DataService } from 'src/app/services/data.service';

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, NavController } from '@ionic/angular';

@Component({
  selector: 'app-subscribe-radial',
  templateUrl: './subscribe-radial.page.html',
  styleUrls: ['./subscribe-radial.page.scss'],
})
export class SubscribeRadialPage implements OnInit {
  subscriptionOptions;
  subscriptionOptionsBackup = [
    {
      name: 'sr',
      type: 'complete',
      message:
        'El usuario tendrá derecho a un viaje de ida y otro viaje de vuelta de lunes a viernes para el radial especificado.',
    },
    {
      name: 'srf',
      type: 'complete',
      message:
        'El usuario tendrá derecho a un viaje de ida y otro viaje de vuelta de lunes a viernes para el radial especificado con opción a modificar.',
    },
    {
      name: 'ss',
      type: 'go',
      message: 'El usuario tendrá derecho a un viaje de ida de lunes a viernes para el radial especificado.',
    },
    {
      name: 'ss',
      type: 'return',
      message: 'El usuario tendrá derecho a un viaje de vuelta de lunes a viernes para el radial especificado.',
    },
    {
      name: 'ssf',
      type: 'go',
      message:
        'El usuario tendrá derecho a un viaje de ida de lunes a viernes para el radial especificado con opción a modificar.',
    },
    {
      name: 'ssf',
      type: 'return',
      message:
        'El usuario tendrá derecho a un viaje de vuelta de lunes a viernes para el radial especificado con opción a modificar.',
    },
  ];

  mySubscription;
  actualSubscription;

  constructor(
    private dataService: DataService,
    private alertCtrl: AlertController,
    private navCtrl: NavController,
    private router: Router,
    private apiService: ApiService,
    private alertController: AlertController
  ) {}

  ngOnInit() {
    this.actualSubscription = this.dataService.getData('subscription');
    if (!this.actualSubscription) {
      this.navCtrl.navigateRoot(['/tecservice-transportec/transportec']);
    }
    this.getTranportecSubscriptionOptions();
  }

  getTranportecSubscriptionOptions() {
    this.apiService.getData('suscription-transportec-options').then((res) => {
      console.log('Options: ', res);
      this.subscriptionOptions = res.data;
    });
  }

  select(subscription) {
    this.mySubscription = subscription;
    this.actualSubscription.name = subscription.name.toUpperCase();
    this.actualSubscription.type = subscription.type;
    this.actualSubscription.sto_id = subscription.id;
  }

  async showInfo(subscription) {
    const alert = await this.alertCtrl.create({
      message: this.returnMessage(subscription),
      buttons: [
        {
          text: 'OK',
          role: 'cancel',
          handler: () => {},
        },
      ],
    });
    alert.present();
  }

  returnMessage(subscription) {
    let message;
    switch (subscription.name.toLowerCase()) {
      case 'sr':
        message =
          'El usuario tendrá derecho a un viaje de ida y otro viaje de vuelta de lunes a viernes para el radial especificado.';
        break;
      case 'srf':
        message =
          'El usuario tendrá derecho a un viaje de ida y otro viaje de vuelta de lunes a viernes para el radial especificado con opción a modificar.';
        break;
      case 'ss':
        message =
          'El usuario tendrá derecho a un viaje de ida o vuelta de lunes a viernes para el radial especificado.';
        break;
      case 'ssf':
        message =
          'El usuario tendrá derecho a un viaje de ida o vuelta de lunes a viernes para el radial especificado con opción a modificar.';
        break;
    }
    return message;
  }

  goSuscription() {
    // subscription.type = this.mySubscription.type;
    console.log('enviando: ', this.actualSubscription);
    this.dataService.setData('subscription', this.actualSubscription);
    this.router.navigate(['/tecservice-transportec/subscription']);
  }

  async presentAlertConfirm(option) {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Métodos de pago',
      message:
        'Los métodos de pago para pago de suscripción son Tarjeta de crédito/débito y Wallet, para el pago con Wallet, es necesario contar previamente con saldo disponible suficiente para el pago.',
      buttons: [
        {
          text: 'Recargar Wallet',
          cssClass: 'secondary',
          handler: (blah) => {
            this.router.navigate(['/tecservice-transportec/wallet/balance']);
          },
        },
        {
          text: 'Continuar',
          handler: () => {
            this.select(option);
          },
        },
      ],
    });

    await alert.present();
  }
}
